<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="BUCKET:">
				<el-input size="small" v-model="ruleForm.bucket"></el-input>
			</el-form-item>
			
			<el-form-item label="EndPoint:">
				<el-input size="small" v-model="ruleForm.endpoint"></el-input>
			</el-form-item>
			
			<el-form-item label="ossType:">
				<el-input size="small" v-model="ruleForm.ossType"></el-input>
			</el-form-item>
			
			<el-form-item label="ossTypeDesc:">
				<el-input size="small" v-model="ruleForm.ossTypeDesc"></el-input>
			</el-form-item>
			
			<el-form-item label="KeyId:">
				<el-input size="small" v-model="ruleForm.accessKeyId"></el-input>
			</el-form-item>
			
			<el-form-item label="Secret:">
				<el-input size="small" v-model="ruleForm.accessKeySecret"></el-input>
			</el-form-item>
			
			
			<el-form-item>
				<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
	    data() {
			return {
				rules: {
					title: [{required: true, message: '请输入标题', trigger: 'blur'}],
					content: [{required: true, message: '请输入公告内容', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Dev/saveOss", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 90px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
	  }
	  .avatar {
	    min-width: 90px;
	    height: 90px;
	    display: block;
	  }
</style>